module.exports = __webpack_public_path__ + "mainassets/img/meshlin-double arrow-right.c3112453.svg";